import { MasterDataBillingCountry } from 'src/generated/api/dsv-public/model';

export const mapCountryToCode = (countryInput: string, billingCountries?: MasterDataBillingCountry[]): string => {
  if (!billingCountries || !countryInput) {
    return 'CH';
  }

  const countryStr = String(countryInput).trim();

  if (countryStr.length === 2) {
    const existingCountry = billingCountries.find(country => country.value === countryStr.toUpperCase());
    return existingCountry ? countryStr.toUpperCase() : 'CH';
  }

  const matchedCountry = billingCountries.find(country => {
    const names = Object.values(country.name);
    return names.some(name => name && name.toLowerCase() === countryStr.toLowerCase());
  });

  return matchedCountry ? matchedCountry.value : 'CH';
};
